export interface CEPData {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  erro?: boolean;
}

/**
 * Busca dados de endereço através do CEP usando a API ViaCEP
 * @param cep - CEP no formato "00000000" ou "00000-000"
 * @returns Dados do endereço ou null se não encontrado
 */
export async function buscarCEP(cep: string): Promise<CEPData | null> {
  // Remove caracteres não numéricos
  const cepLimpo = cep.replace(/\D/g, '');

  // Valida se tem 8 dígitos
  if (cepLimpo.length !== 8) {
    return null;
  }

  try {
    const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
    
    if (!response.ok) {
      throw new Error('Erro ao buscar CEP');
    }

    const data: CEPData = await response.json();

    // ViaCEP retorna erro: true quando não encontra
    if (data.erro) {
      return null;
    }

    return data;
  } catch (error) {
    console.error('Erro ao buscar CEP:', error);
    return null;
  }
}

/**
 * Formata CEP para o padrão brasileiro (00000-000)
 */
export function formatarCEP(cep: string): string {
  const cepLimpo = cep.replace(/\D/g, '');
  
  if (cepLimpo.length <= 5) {
    return cepLimpo;
  }
  
  return `${cepLimpo.slice(0, 5)}-${cepLimpo.slice(5, 8)}`;
}

